import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const DocSigningNavUI = ({ context, loan, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='Document signing' to={`/su/loans/${loan.loanId}/esigning`} active={page === 'esigning'} />
      <TabLinkUI label='Addendum' to={`/su/loans/${loan.loanId}/addendum`} active={page === 'addendum'} />
    </div>
    <div className='g_m_top_50' />
  </div>

export default DocSigningNavUI
